module.exports = __webpack_public_path__ + "static/media/heart.7ba3efea.png";


//////////////////
// WEBPACK FOOTER
// ./src/heart.png
// module id = 294
// module chunks = 0